import type {
  EditUserGroupDataType,
  UserManagementType,
} from "@/redux/userManagement/userManagementTypes";

export const initialState: UserManagementType = {
  fetching: false,
  success: null,
  error: null,
  statusCode: null,
  moduleList: [],
  sideMenuList: [],
  othersList: [],
  userGroupList: [],
  userGroupCount: 0,
  editUserGroupData: {} as EditUserGroupDataType,
  assignedGroupList: [],
  assignedUsersToGroupList: [],
  assignedGroupListCount: 0,
  createMenuMessage: {} as any,
  menuList: [] as any,
  group_menu: [],
  group_name: "",
};
